import { useTranslation } from 'react-i18next';
import {
  Avatar,
  AvatarFallback,
  AvatarPlaceholder,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Text,
} from '@shared/ui';

export function AvatarShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.dataDisplay.avatar.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.dataDisplay.avatar.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Text size="sm" color="muted">
          {t('uiLibrary.dataDisplay.avatar.note')}
        </Text>
        <div className="flex items-center gap-4">
          <Avatar>
            <AvatarFallback>
              <AvatarPlaceholder />
            </AvatarFallback>
          </Avatar>
        </div>
      </CardContent>
    </Card>
  );
}
